<template>
  <div
    v-if="title"
    class="scene-title-overlay"
    :class="[`pos-${position}`]"
  >
    <span class="scene-title-text">{{ title }}</span>
    <span v-if="showCounter && total > 1" class="scene-counter">{{ current }} / {{ total }}</span>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  title: string
  position: 'top-center' | 'top-left' | 'bottom-left'
  showCounter: boolean
  current: number
  total: number
}>(), {
  position: 'top-center',
  showCounter: false,
  current: 1,
  total: 1,
})
</script>

<style scoped>
.scene-title-overlay {
  position: absolute;
  z-index: 13;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(8px);
  border-radius: 8px;
  pointer-events: none;
}

.pos-top-center {
  top: 14px;
  left: 50%;
  transform: translateX(-50%);
}

.pos-top-left {
  top: 14px;
  left: 14px;
}

.pos-bottom-left {
  bottom: 14px;
  left: 14px;
}

.scene-title-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scene-counter {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .scene-title-overlay {
    padding: 6px 12px;
  }

  .pos-top-center {
    top: 10px;
    left: 12px;
    transform: none;
    right: auto;
  }

  .scene-title-text {
    font-size: 12px;
    max-width: 180px;
  }

  .scene-counter {
    font-size: 11px;
  }
}
</style>
